import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  }
};

function ButtonsMoreChecked({ handleOpenDelete }) {
  const { dictionary } = useGlobalContext();

  return (
    <>
      <div style={{ width: "25%" }}></div>
      <div style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["stampaj"]}
        </Button>
      </div>
      <div style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["posalji"]}
        </Button>
      </div>
      <div onClick={handleOpenDelete} style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["izbrisi"]}
        </Button>
      </div>
    </>
  );
}

export default ButtonsMoreChecked;
